const DeletedMediaConstantsAr = {
  deletedMediaPageTitle: 'الوسائط المحذوفة',
  deletedMediaTitle: 'العنوان',
  DeletedmediagoBack: ' العودة ',
  deletedMediaDeletedDate: 'تاريخ الحذف',
  deletedMediaId: 'رقم',
  deletedMediaBrightcoveId:'الرقم في المخزون',
  deletedMediaReferenceId: 'الرقم المرجعي',
  totalDeletedMedia: 'إجمالي الوسائط المحذوفة',
  deletedMediaTableIdColumn: 'المعرف',
  deletedMediaTableTitleColumn: 'العنوان',
  deletedMediaTableDeletedDateColumn: 'تاريخ الحذف'
};
export default DeletedMediaConstantsAr;
